import {createRule, type Maybe} from '@regle/core';
import {maxValue} from '@regle/rules';
import {useTranslation} from '#imports';

/**
 * Requires a field to have a specified maximum year value.
 *
 * @param maxYear - the maximum year
 *
 * @example
 * ```ts
 *  import { useRegle, maxYear } from '@malt/forms';
 *
 *  const { r$ } = useRegle(... , {
 *    graduationYear: { maxYear: maxYear(2030) }
 *  })
 * ```
 */
export const maxYear = createRule({
    type: 'maxValue',
    validator: (value: Maybe<number>, maxYear: number, options?: {allowEqual: boolean}) => {
        return maxValue(maxYear, options).exec(value);
    },
    message: ({$params: [maxYear, options]}) => {
        const {t} = useTranslation();

        return (options?.allowEqual ?? true)
            ? t('generic.forms.validation.errors.maxYear.equal', [String(maxYear)])
            : t('generic.forms.validation.errors.maxYear', [String(maxYear)]);
    },
});
